import { BeneficiaryFilterItem } from '@repo/shared/dtos/beneficiary'
import { Card, CardContent, CardDescription, CardHeader } from '@repo/ui/card'
import { CardTitle } from '@repo/ui/card'
import { useT } from '@repo/ui/hooks'
import { useState } from 'react'
import { useSelector } from 'react-redux'

import { AddFilter } from '@/components/beneficiary/list/AddFilter'
import { BeneficiaryListFilters } from '@/components/beneficiary/list/BeneficiaryListFilters'
import { FilterAndSchemaItemList } from '@/store/beneficiary-list-filters/types'
import { getCurrentOrganizationStructuredDataSchema } from '@/store/user'

import { FormType } from './types'

export default function FiltersForm({ form }: { form: FormType }) {
  const { t } = useT({ keyPrefix: 'admin.insights.form.filters' })
  const [open, setOpen] = useState(false)
  const structuredDataSchema = useSelector(getCurrentOrganizationStructuredDataSchema)

  const filters = form.watch('filters')

  const data: FilterAndSchemaItemList = filters
    .map((filter) => ({
      filter,
      schemaItem: structuredDataSchema?.find((item) => item.id === filter.key),
    }))
    .filter((item) => !!item.schemaItem) as FilterAndSchemaItemList

  const availableSchemaItems = structuredDataSchema?.filter(
    (item) => !filters.some((f) => f.key === item.id),
  )

  const addFilter = (filter: BeneficiaryFilterItem) => {
    form.setValue('filters', [...filters, filter])
    setOpen(false)
  }
  const removeFilter = (filter: BeneficiaryFilterItem) => {
    form.setValue(
      'filters',
      filters.filter((f) => f.key !== filter.key),
    )
  }
  const updateFilter = (filter: BeneficiaryFilterItem) => {
    form.setValue(
      'filters',
      filters.map((f) => (f.key === filter.key ? filter : f)),
    )
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t('title')}</CardTitle>
        <CardDescription>{t('description')}</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="flex flex-row items-start gap-4">
          <BeneficiaryListFilters
            data={data}
            onRemove={removeFilter}
            onUpdate={(filter) => updateFilter(filter)}
          />
          <AddFilter
            schemaItems={availableSchemaItems ?? []}
            onAdd={(filter) => addFilter(filter)}
            disabled={false}
            open={open}
            setOpen={setOpen}
          />
        </div>
      </CardContent>
    </Card>
  )
}
